import { gql, useLazyQuery } from "@apollo/client";
import React, { useCallback, useState } from "react";
import { usePicklists } from "ticketing/contexts/picklists/PicklistContextProvider";
import { GqlResponse, TProduct } from "ticketing/ticketing.types";

// for type ahead
export const GQL = gql`
  query productsFilterBy($enterpriseSystemId: Int!, $name: String!) {
    products: productsFilterBy(
      filter: { enterpriseSystemId: $enterpriseSystemId, name: { regexIgnoreCase: $name } }
    ) {
      id
      name
      superFundTax
    }
  }
`;

const delay = 500;
type Response = GqlResponse<TProduct[], "products">;
const useSearchProducts = () => {
  const { picklists } = usePicklists();
  const [searchResults, setSearchResults] = useState<TProduct[]>([]);

  const [filter, { loading, error }] = useLazyQuery<Response>(GQL, {
    errorPolicy: "all",
    fetchPolicy: "no-cache",
    onCompleted: data => setSearchResults(data.products)
  });

  const timeout = React.useRef<ReturnType<typeof setTimeout> | null>(null);

  const search = (name: string) => {
    if (timeout.current) {
      clearTimeout(timeout.current);
    }
    timeout.current = setTimeout(() => {
      filter({
        variables: { enterpriseSystemId: picklists?.enterpriseSystemId, name: `%${name}%` }
      });
    }, delay);
  };

  const clear = useCallback(() => {
    setSearchResults([]);
  }, [setSearchResults]);
  return [search, searchResults, loading, error, clear] as const;
};

export default useSearchProducts;
